import TableFooter from "./tableFooter"

export default TableFooter
